import React from 'react'
import { connect } from 'react-redux';
import { IAdmin } from '../../../../Utils/types';
import {
  adminsSelector,
  adminsStatusSelector,
  getAdmins,
  removeAdmin,
  addAdmin,
  setNewAdmin
} from '../../../../Redux/Reducers/adminsReducer';
import { localization } from '../../../../Utils/Localization/localization';
import { languageSelector } from '../../../../Redux/Reducers/settingsReducer';
import classes from './ProfilePage.module.scss';
import { Button } from 'antd';
import { AdminEdit } from './AdminEdit';
import { NewAdmin } from './NewAdmin';

interface AdminProps {
  id: number | string,
  currentUserId: number,
  email: string | string,
  level: number | string,
  language: string,
  handleEdit: () => void
}
function Admin(props: AdminProps) {
  const permissionLevelForEdit = 2;
  return (
    <li>
      <div>
        {props.id}
      </div>
      <div>
        {props.email}
      </div>
      <div>
        {props.level}
      </div>
      <div>
      </div>
      <div>
        <Button
          onClick={props.handleEdit}
          disabled={props.currentUserId === props.id || !(permissionLevelForEdit >= props.level)}
        >
          {
            !(permissionLevelForEdit >= props.level)
              ? localization('noPermission', props.language)
              : props.currentUserId === props.id
                ? localization('cannotEditSelf', props.language)
                : localization('edit', props.language)
          }
        </Button>
      </div>
    </li>
  );
}

interface StateProps {
  admins: IAdmin[],
  status: string,
  language: string
}
interface DispatchProps {
  getAdmins: () => void
  removeAdmin: (id: number) => void,
  addAdmin: () => void,
  setNewAdmin: (name: string, value: any) => void
}
interface Props extends StateProps, DispatchProps {
  currentUserId: number,
  currentUserLevel: number
}

function Admins(props: Props) {
  const [edit, setEdit] = React.useState(false);
  const [currentAdmin, setCurrentAdmin] = React.useState(-1);

  React.useEffect(() => {
    props.getAdmins();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleEdit(id: number) {
    setCurrentAdmin(id);
    handleVisible();
  }

  function handleVisible() {
    setEdit(!edit);
  }

  return (
    <>
      <h2>{localization('admins', props.language)}</h2>
      {
        props.status === 'loaded'
          ?
          <>
            {
              currentAdmin !== -1
              && <AdminEdit
                handleVisible={handleVisible}
                visible={edit}
                initialLevel={props.admins[currentAdmin].level}
                currentAdmin={props.admins[currentAdmin].id}
                resetCurrentAdmin={() => handleEdit(-1)}
              />}
            <ul className={classes.Admins}>
              <NewAdmin userLevel={props.currentUserLevel} />
              <li>
                <div>
                  {localization('adminId', props.language)}
                </div>
                <div>
                  {localization('email', props.language)}
                </div>
                <div>
                  {localization('level', props.language)}
                </div>
                <div></div>
                <div></div>
              </li>
              {
                props.admins.map((item, index) => {
                  return (
                    <Admin
                      email={item.email}
                      id={item.id}
                      currentUserId={props.currentUserId}
                      level={item.level}
                      language={props.language}
                      handleEdit={() => handleEdit(index)}
                      key={item.id}
                    />
                  );
                })
              }
            </ul>
          </>
          : localization('wait', props.language)
      }
    </>
  );
}

function mapStateToProps(state: any) {
  return {
    admins: adminsSelector(state),
    status: adminsStatusSelector(state),
    language: languageSelector(state)
  }
}
const mapDispatchToProps = {
  getAdmins,
  removeAdmin,
  addAdmin,
  setNewAdmin
}

const ConnectedAdmins = connect(mapStateToProps, mapDispatchToProps)(Admins);
export { ConnectedAdmins as Admins };

